"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.onScrollbarRelease = exports.isDragging = exports.handleLoad = void 0;
const highcharts_1 = __importDefault(require("highcharts/highcharts"));
const chevronLeftCircle_svg_1 = __importDefault(require("../../../assets/icons/chevronLeftCircle.svg"));
const chevronRightCircle_svg_1 = __importDefault(require("../../../assets/icons/chevronRightCircle.svg"));
const graphChevronLeft_svg_1 = __importDefault(require("../../../assets/icons/graphChevronLeft.svg"));
const graphChevronRight_svg_1 = __importDefault(require("../../../assets/icons/graphChevronRight.svg"));
const mobileChevronLeft_svg_1 = __importDefault(require("../../../assets/icons/mobileChevronLeft.svg"));
const mobileChevronRight_svg_1 = __importDefault(require("../../../assets/icons/mobileChevronRight.svg"));
const DIRECTION_LEFT = "left";
const DIRECTION_RIGHT = "right";
let onScrollbarRelease = null;
exports.onScrollbarRelease = onScrollbarRelease;
let isDragging = false;
exports.isDragging = isDragging;
const addScrollbarDragDetection = (chart) => {
    // Detect when the mouse is down on the scrollbar
    highcharts_1.default.addEvent(chart.container, "mousedown", function (e) {
        var _a;
        const target = e === null || e === void 0 ? void 0 : e.target;
        const classNames = ((_a = target === null || target === void 0 ? void 0 : target.className) === null || _a === void 0 ? void 0 : _a.toString()) || "";
        if (classNames.includes("highcharts-scrollbar") ||
            classNames.includes("highcharts-navigator") ||
            classNames.includes("highcharts-navigator-handle") ||
            classNames.includes("highcharts-navigator-mask") ||
            classNames.includes("highcharts-navigator-track") ||
            classNames.includes("highcharts-navigator-series") ||
            (target === null || target === void 0 ? void 0 : target.closest(".highcharts-scrollbar")) ||
            (target === null || target === void 0 ? void 0 : target.closest(".highcharts-navigator"))) {
            exports.isDragging = isDragging = true;
        }
    });
    // Handle mouseup event
    const handleMouseUp = function () {
        if (isDragging) {
            exports.isDragging = isDragging = false;
            // Execute callback when scrollbar is released
            if (onScrollbarRelease) {
                onScrollbarRelease();
            }
        }
    };
    // Add mouseup listeners
    highcharts_1.default.addEvent(document, "mouseup", handleMouseUp);
    highcharts_1.default.addEvent(chart.container, "mouseup", handleMouseUp);
    highcharts_1.default.addEvent(chart.container, "mouseleave", handleMouseUp);
    // "Any" type is because of a bug in highcharts. If you log chart you will see that is has a scroller propertie.
    if (chart.scroller) {
        highcharts_1.default.addEvent(chart.scroller, "mouseup", handleMouseUp);
    }
    if (chart.navigator) {
        highcharts_1.default.addEvent(chart.navigator, "mouseup", handleMouseUp);
    }
};
const addNavigationArrows = (chart, isCalendarPage, isMobile) => {
    if (isMobile && !isCalendarPage) {
        return;
    }
    if (chart.renderer.boxWrapper.element.querySelectorAll(".custom-arrow").length >
        0) {
        return;
    }
    let leftArrow;
    let rightArrow;
    const updateArrowStates = () => {
        const axis = chart.xAxis[0];
        const { min, max, dataMin, dataMax } = axis.getExtremes();
        leftArrow.css({
            cursor: min <= dataMin ? "not-allowed" : "pointer",
            opacity: min <= dataMin ? 0.5 : 1,
        });
        rightArrow.css({
            cursor: max >= dataMax ? "not-allowed" : "pointer",
            opacity: max >= dataMax ? 0.5 : 1,
        });
    };
    const move = (direction) => {
        const axis = chart.xAxis[0];
        const { min, max, dataMin, dataMax } = axis.getExtremes();
        const range = max - min;
        const moveAmount = range * 0.1;
        const newMin = direction === DIRECTION_LEFT
            ? Math.max(dataMin, min - moveAmount)
            : Math.min(dataMax - range, min + moveAmount);
        const newMax = direction === DIRECTION_LEFT
            ? Math.max(dataMin + range, max - moveAmount)
            : Math.min(dataMax, max + moveAmount);
        axis.setExtremes(newMin, newMax, true, false, { trigger: "syncExtremes" });
        updateArrowStates();
    };
    const toggleElements = (display) => {
        const elements = [
            ".highcharts-tooltip",
            ".highcharts-point",
            ".highcharts-crosshair",
            ".highcharts-halo",
        ];
        elements.forEach((selector) => {
            const element = chart.container.querySelector(selector);
            if (element)
                element.style.display = display;
        });
    };
    const createArrows = () => {
        const chartWidth = chart.chartWidth;
        const chartHeight = chart.chartHeight;
        // Remove existing arrows if any
        chart.renderer.boxWrapper.element
            .querySelectorAll(".custom-arrow")
            .forEach((el) => el.remove());
        const leftIcon = isMobile
            ? mobileChevronLeft_svg_1.default
            : isCalendarPage
                ? chevronLeftCircle_svg_1.default
                : graphChevronLeft_svg_1.default;
        const rightIcon = isMobile
            ? mobileChevronRight_svg_1.default
            : isCalendarPage
                ? chevronRightCircle_svg_1.default
                : graphChevronRight_svg_1.default;
        let iconSize = 48;
        let leftArrowX = 15;
        let rightArrowX = chartWidth - 118;
        let arrowY = chartHeight / 2;
        if (isMobile && isCalendarPage) {
            iconSize = 40;
            leftArrowX = 0;
            rightArrowX = chartWidth - 50;
            arrowY = -29;
        }
        else if (!isMobile && isCalendarPage) {
            iconSize = 46;
            leftArrowX = -70;
            rightArrowX = chartWidth + 25;
            arrowY = chartHeight / 2 - 24;
        }
        else if (!isMobile && !isCalendarPage) {
            iconSize = 48;
            leftArrowX = 15;
            rightArrowX = chartWidth - 118;
            arrowY = chartHeight / 2 - 24;
        }
        leftArrow = chart.renderer
            .image(leftIcon, leftArrowX, arrowY, iconSize, iconSize)
            .attr({ zIndex: 10, class: "custom-arrow" })
            .css({ cursor: "pointer" })
            .add();
        rightArrow = chart.renderer
            .image(rightIcon, rightArrowX, arrowY, iconSize, iconSize)
            .attr({ zIndex: 10, class: "custom-arrow" })
            .css({ cursor: "pointer" })
            .add();
        leftArrow.on("click", () => {
            if (leftArrow.element.style.cursor !== "not-allowed") {
                move(DIRECTION_LEFT);
            }
        });
        rightArrow.on("click", () => {
            if (rightArrow.element.style.cursor !== "not-allowed") {
                move(DIRECTION_RIGHT);
            }
        });
        leftArrow.on("mouseover", () => toggleElements("none"));
        leftArrow.on("mouseout", () => toggleElements("block"));
        rightArrow.on("mouseover", () => toggleElements("none"));
        rightArrow.on("mouseout", () => toggleElements("block"));
        updateArrowStates();
        highcharts_1.default.addEvent(chart, "redraw", () => {
            updateArrowStates();
            leftArrow.attr({ x: leftArrowX, y: arrowY });
            rightArrow.attr({
                x: rightArrowX,
                y: arrowY,
            });
        });
    };
    createArrows();
    highcharts_1.default.addEvent(chart, "resize", createArrows);
};
const handleLoad = function (isCalendarPage, isMobile) {
    addNavigationArrows(this, isCalendarPage, isMobile);
    addScrollbarDragDetection(this);
};
exports.handleLoad = handleLoad;
